import { render, staticRenderFns } from "./drawer-account.vue?vue&type=template&id=48897e46&scoped=true&"
import script from "./drawer-account.vue?vue&type=script&lang=js&"
export * from "./drawer-account.vue?vue&type=script&lang=js&"
import style0 from "./drawer-account.vue?vue&type=style&index=0&id=48897e46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48897e46",
  null
  
)

export default component.exports